import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import {
  FaRegQuestionCircle,
  FaRegBookmark,
  FaBookmark,
  FaRegCircle,
  FaCircle,
  FaQuestion,
} from 'react-icons/fa';
import { useUnit } from 'hooks/units';
import styles from 'styles/Unit.module.scss';
import classnames from 'classnames';
import { BsQuestion } from 'react-icons/bs';

const QuestionInfo = ({
  totalQuesttion,
  current,
  callGrandchildFunction,
  bookmarked,
  setBookmarked,
  quizPosition,
  toggleBookmark,
  availablePosition,
  durationDisable,
  isLoading,
}) => {
  const unitSelected = useUnit();

  const handleQuestionClick = (id) => {
    callGrandchildFunction(id);
  };

  return (
    <div style={{ position: 'relative' }}>
      {(isLoading || durationDisable) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 2,
            cursor: 'not-allowed',
          }}
        />
      )}
      <Card
        style={{
          height: '100vh',
          overflowY: 'auto',
          boxShadow: 'none',
          border: '1px solid #e6e6e6',
          position: 'relative',
        }}
      >
        <h5
          style={{ padding: '20px 15px' }}
          className="d-flex align-items-center ml-1"
        >
          Questions
        </h5>
        <ul className="list-unstyled">
          {quizPosition?.map((element, index) => {
            // const id = i + 1;
            const id = element;
            const isCompleted = unitSelected?.results?.some(
              (element) =>
                element.order == id &&
                (element.hasOwnProperty('isEmpty') && element?.isEmpty !== null
                  ? element?.isEmpty == false
                  : true),
            );

            return (
              <li
                key={id}
                className={`d-flex align-items-center p-1 ${classnames(
                  styles.listItem,
                )}`}
                style={{
                  backgroundColor: id === current ? '#bfddff' : 'transparent',
                  borderBottom: '1px solid #ddd',
                  cursor: 'pointer',
                }}
              >
                {isCompleted ? (
                  <FaCircle style={{ marginRight: 5 }} color="grey" />
                ) : (
                  <FaRegCircle style={{ marginRight: 5 }} color="grey" />
                )}
                {/* <BsQuestion
                  color="grey"
                  size={22}
                  onClick={() => handleQuestionClick(id)}
                /> */}
                <span
                  className="ml-1 ms-2"
                  onClick={() => handleQuestionClick(id)}
                >
                  Question {index + 1}
                </span>
                <span
                  className="ml-auto me-2"
                  onClick={() => toggleBookmark(id)}
                  style={{ cursor: 'pointer' }}
                >
                  {bookmarked?.[id] ? (
                    <FaBookmark color="gold" />
                  ) : (
                    <FaRegBookmark />
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      </Card>
    </div>
  );
};

export default QuestionInfo;

{
  /* <ul className="list-unstyled">
        {Array.from({ length: totalQuesttion }, (_, i) => {
          const id = i + 1;
          const isCompleted = unitSelected?.results?.some(
            (element) => element.order == id,
          );

          return (
            <li
              key={id}
              className={`d-flex align-items-center p-1`}
              style={{
                backgroundColor: id === current ? '#bfddff' : 'transparent',
                borderBottom: '1px solid #ddd',
                cursor: 'pointer',
              }}
            >
              {isCompleted ? (
                <FaCircle style={{ marginRight: 3 }} color="grey" />
              ) : (
                <FaRegCircle style={{ marginRight: 3 }} color="grey" />
              )}
              <FaRegQuestionCircle
                color="grey"
                onClick={() => handleQuestionClick(id)}
              />
              <span
                className="ml-1 ms-2"
                onClick={() => handleQuestionClick(id)}
              >
                Question {id}
              </span>
              <span
                className="ml-auto me-2"
                onClick={() => toggleBookmark(id)}
                style={{ cursor: 'pointer' }}
              >
                {bookmarked[id] ? (
                  <FaBookmark color="gold" />
                ) : (
                  <FaRegBookmark />
                )}
              </span>
            </li>
          );
        })}
      </ul> */
}
